import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from "primeng/components/common/message";
import { EditEventModel } from "../../../../models/inModels/Event";
import { EditNotificationContentTypeViewModel } from "../../../../models/inModels/NotificationContentType";
import { NotificationTypeService } from "../../../../services/notifications/notification.service";

@Component({
  selector: 'app-types-edit',
  templateUrl: './types-edit.component.html',
  styleUrls: ['./types-edit.component.css']
})
export class TypesEditComponent implements OnInit {
	id;
	model: EditNotificationContentTypeViewModel;
	loading = false;
	error: Message[];
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: NotificationTypeService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.get();
	}

	get() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditNotificationContentTypeViewModel(result);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

  
  goBack(): void {
	  this.router.navigate(['/notification/types']);
  }

  save() {
	  this.loading = true;
	  this.service.update(this.model).then(
		  result => {
			  this.loading = false;
			  this.model = new EditNotificationContentTypeViewModel(result);
			  this.error = [];
			  this.error.push({ severity: 'success', summary: 'Success', detail: "Event saved" });
			  this.goBack();
		  },
		  error => {
			  this.loading = false;
			  this.error = [];
			  this.error.push({ severity: 'error', summary: 'Error', detail: error });
		  });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/notification/types/types-edit/types-edit.component.ts